import styled from "styled-components";

export const Row = styled("div")`
   display: flex;
   flex-direction: row;
`;

export const RowCentered = styled("div")`
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
`;
